import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;

  .ai-wrapper {
    position: relative;
    padding: 24px;
    background: linear-gradient(90deg, rgba(0, 123, 255, 0.05), rgba(0, 159, 121, 0.05));
    z-index: 0;
  }

  .ai-wrapper::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 0.25rem;

    background: linear-gradient(90deg, #007bff, #009f79);

    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;

    pointer-events: none;
  }

  .ai-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;
  }

  .ai-icon {
    width: 40px;
    height: 40px;
    border-radius: 0.25rem;
    background: linear-gradient(90deg, #007bff 0%, #009f79 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .ai-title {
    font-size: 24px;
    font-weight: 500;
    color: #0f172a;
    margin: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  .ai-subtitle {
    font-size: 13px;
  }

  .ai-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }

  .ai-card {
    position: relative;
    background: #ffffff;
    border-radius: 0.25rem;
    padding: 18px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .ai-card::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 0.25rem;

    background: linear-gradient(90deg, #007bff, #009f79);

    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;

    pointer-events: none;
  }

  .ai-badge {
    display: inline-block;
    color: rgba(54, 103, 147, 1);
    border: 1.5px solid var(--Brand-Blue-600, rgba(54, 103, 147, 1));
    border-radius: 4px;
    margin-bottom: 16px;
    padding: 4px 8px;
  }

  .ai-card-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 4px;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .ai-card-description {
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 14px;

    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .ai-card-date {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 8px;
  }

  .ai-card-date span {
    font-size: 16px;
    color: #9ca3af;
  }

  .ai-link {
    font-size: 16px;
    font-weight: 600;

    background: linear-gradient(90deg, #007bff, #009f79);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    color: transparent;

    border: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    padding: 0;
    text-decoration: none;
  }

  .ai-link:visited {
    text-decoration: none;
  }

  .ai-footer {
    font-size: 12px;
    color: rgba(108, 117, 125, 1);
    text-align: center;
  }

  .divisor {
    border: none;
    height: 1px;
    background: linear-gradient(90deg, #007bff, #009f79);
  }

  @media (max-width: 1024px) {
    .ai-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    .ai-grid {
      grid-template-columns: 1fr;
    }
  }
`;
